import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TMassPostSaleJobsStore } from './types';

const getMassPostSaleJobsState = (state: TStoreState): TMassPostSaleJobsStore =>
	state.massPostSaleJobs;

// ====== Jobs ======

export const getMassPostSaleJobs = createSelector(
	[getMassPostSaleJobsState],
	(state) => state.jobs,
);

export const getMassPostSaleJobsLoading = createSelector(
	[getMassPostSaleJobsState],
	(state) => state.jobsLoading,
);

// ====== Job orders ======

export const getMassPostSaleJobOrders = createSelector(
	[getMassPostSaleJobsState],
	(state) => state.jobOrders,
);

export const getMassPostSaleJobOrdersLoading = createSelector(
	[getMassPostSaleJobsState],
	(state) => state.jobOrdersLoading,
);
